import React from 'react';
import IconChevronLeft from '../../svg/IconChevronLeft';
import IconChevronRight from '../../svg/IconChevronRight';

const activeIcon = {
    verticalAlign: 'top',
    cursor: 'pointer',
    fill: '#414141'
};
const inactiveIcon = {
    verticalAlign: 'top',
    cursor: 'auto',
    fill: '#D1D1D1'
};

const PageNavigator = ({
    hasPreviousPage,
    hasNextPage,
    isFirstPage,
    isLastPage,
    onPrevClick,
    onNextClick
}) => {
    return (
        <div>
            <IconChevronLeft
                width={15}
                height={18}
                style={
                    isFirstPage
                        ? inactiveIcon
                        : hasPreviousPage
                        ? activeIcon
                        : inactiveIcon
                }
                onClick={hasPreviousPage ? onPrevClick : null}
            />
            <div style={{ display: 'inline-block', width: 15 }} />
            <IconChevronRight
                width={15}
                height={18}
                style={
                    isLastPage
                        ? inactiveIcon
                        : hasNextPage
                        ? activeIcon
                        : inactiveIcon
                }
                onClick={hasNextPage ? onNextClick : null}
            />
        </div>
    );
};

export default PageNavigator;
